import axios from "axios";
import * as urlConfig from "../configs/urlConfig";

class HreflangService {
  /**
   * Fetches live countries for a brand and creates hreflang links
   * @param {string} brand - Brand name (e.g., 'beko', 'grundig')
   */
  fetchCountriesAndSetLinks = async (brand) => {
    try {
      // Use the configured API URL instead of hardcoded URL
      const response = await axios.get(`${urlConfig.GET_LIVE_COUNTRIES_BY_BRAND}${brand}`);
      const liveCountries = response.data || [];
      
      // Remove existing hreflang links
      document.querySelectorAll("link[rel='alternate']").forEach(link => link.remove());

      // Create hreflang links for each country
      liveCountries.forEach(country => {
        const link = document.createElement("link");
        link.rel = "alternate";
        link.href = country.redirectionUrl;

        const urlSegments = country.redirectionUrl.split('/');
        const langRegionCode = urlSegments[urlSegments.length - 1];
        const [language, region] = langRegionCode.split('-');
        link.hreflang = `${language.toLowerCase()}-${region.toUpperCase()}`;

        document.head.appendChild(link);
      });

      // Add default hreflang link
      const defaultLink = document.createElement("link");
      defaultLink.rel = "alternate";
      defaultLink.href = `https://${window.location.hostname}/`;
      defaultLink.hreflang = "x-default";
      document.head.appendChild(defaultLink);

      return liveCountries;
    } catch (error) {
      console.error("Error fetching countries for brand:", error);
      return [];
    }
  };

  /**
   * Initialize hreflang links based on current domain
   */
  initializeHreflangLinks = () => {
    const currentDomain = window.location.hostname;
    const brand = currentDomain.split('.')[1];
    
    if (brand) {
      return this.fetchCountriesAndSetLinks(brand);
    }
    
    return Promise.resolve([]);
  };
}

export default new HreflangService();

